const formatPaymentLinksToSendForAPI = (paymentLinks) => {
  /**
   * @PaymentLinks - Format:
   *
   *    {
   *      "link": string;
   *      "office_id": string;
   *    }
   */
  const formattedArray = Object.entries(paymentLinks).map(([id, link]) => ({
    link,
    office_id: id,
  }));

  return formattedArray;
};

export { formatPaymentLinksToSendForAPI };
